<script lang="ts" setup>
import { DropdownItem, Icon } from '@brighterly/lib-lumee-ui'

import { AppRoute } from '@ts-routes/enums'

import amplitudeConfig from '@config/amplitude.json'

import { trackEvent } from '@tools/amplitude'

defineOptions({
  name: 'LinkProfile',
})

const emit = defineEmits<{
  click: []
}>()

const text = 'Profile'

const route = useRoute()
const selected = computed(() => route.path === AppRoute.Profile)

const handleClick = (): void => {
  if (selected.value) return

  trackEvent(amplitudeConfig.events.clickLink, {
    name: 'link_profile',
    link_text: text,
    href: AppRoute.Profile,
  })
  emit('click')
  void navigateTo(AppRoute.Profile)
}

</script>

<template>
  <DropdownItem
    :title="text"
    role="menuitem"
    :aria-selected="undefined"
    :aria-current="selected ? 'page' : undefined"
    :selected="selected"
    @click="handleClick"
  >
    <template #leading>
      <Icon
        name="user"
        size="md"
        color="default"
      />
    </template>
  </DropdownItem>
</template>
